export class DriverLicenceReq
{
  public  DiverID: string;
   public DOB: string;      
   public RegNo: number;
   public ProductCode: string;
   public LICENCE_TYPE: string; 
}

export class DriverLicenceRes
{
   public  DiverID: string;
   public  Name: string;
   public LicenceExpiryDateG: string;
   public LicenceExpiryDateH: string;
   public DriverAge:string;
   public DOB: string;
   public LogId: string;
   public st: YakeenStatusMdl=new YakeenStatusMdl();
}
export class YakeenStatusMdl
{
    public  StatusCode: string;
    public  StatusDecEn: string;
    public StatusDescAr: string;
    public Result: string;
    public msgKey: string;
    
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/DriverLicenceReq.ts